import { render, staticRenderFns } from "./SetDuration.vue?vue&type=template&id=03228d64&"
import script from "./SetDuration.vue?vue&type=script&lang=js&"
export * from "./SetDuration.vue?vue&type=script&lang=js&"
import style0 from "./SetDuration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports